import { GetCreditsLimitParams, getCreditsLimit } from './getCreditsLimit';
import { getBundleChargingModel } from './getBundleChargingModel';

export interface GetDealChargingModelParams extends GetCreditsLimitParams {}

export const getDealChargingModel = ({
  bundleStatus,
  plans,
}: GetDealChargingModelParams) =>
  getBundleChargingModel({
    bundleStatus,
    creditsLimit: getCreditsLimit({ bundleStatus, plans }),
    type: 'deal',
  });
